import React from 'react';
import {AutoField} from '../fields';
import Section from 'components/forms/Section';
import {Typography} from '@material-ui/core';
import fields from 'components/forms/armytoss/fields';
import {getInitialValues, getSchema} from 'components/forms/AutoSection';
import {useFieldData} from 'components/forms/hooks';

const ShipmentDischarge = props => {
    //const vesselName = useFieldData('vessel_name');
    const fieldDict = fields;
    const sectionFields = [
        'department',
        'deck_position_served',
        'engine_position_served',

        'watertype',
        'also_polar',
        'date_reported',
        'date_detached',
        'deck_supervised',
        'deck_performed_under_supervision_days',
        'engine_supervised',
        'engine_performed_under_supervision_days',
        'towing_training',
        'towing_training_and_observation_days',
    ];
    const schema = getSchema(sectionFields, fieldDict);
    const initialValues = getInitialValues({}, sectionFields, fieldDict);

    const [vesselType] = useFieldData('vessel_type', null, 'parent');

    const [department, setDepartment] = useFieldData('department');
    const updateDepartment = e => {
        setDepartment(e.currentTarget.value);
    };
    const [deckSupervised, setDeckSupervised] = useFieldData('deck_supervised');
    const showDeckSupervised = deckSupervised === true || deckSupervised === 'true';

    const updateDeckSupervised = event => {
        setDeckSupervised(event.target.value === 'true');
    };

    const [engineSupervised, setEngineSupervised] =
        useFieldData('engine_supervised');
    const showEngineSupervised =
        engineSupervised === true || engineSupervised === 'true';

    const updateEngineSupervised = event => {
        setEngineSupervised(event.target.value === 'true');
    };
    const [towingTraining, setTowingTraining] = useFieldData('towing_training');
    const showTowingTraining = towingTraining === true || towingTraining === 'true';

    const updateTowingTraining = event => {
        setTowingTraining(event.target.value === 'true');
    };
    const [watertype, setWatertype] = useFieldData('watertype');

    const updateWatertype = e => {
        setWatertype(e.target.value);
    };

    return (
        <Section {...props} schema={schema} initialValues={initialValues}>
            <Typography variant='h6' align='left'>
                Dates
            </Typography>
            <Typography variant='body1' align='left'>
                Now let's enter your service on this vessel, starting with the first
                line.
            </Typography>
            <AutoField
                field={fields['department']}
                name='department'
                onChange={updateDepartment}
            />
            {department === 'Deck' && (
                <AutoField
                    field={fields['deck_position_served']}
                    name='deck_position_served'
                />
            )}
            {department === 'Engine' && (
                <AutoField
                    field={fields['engine_position_served']}
                    name='engine_position_served'
                />
            )}

            {department === 'Deck' && (
                <div>
                    <p />
                    <AutoField
                        field={fields['deck_supervised']}
                        name='deck_supervised'
                        onChange={updateDeckSupervised}
                    />
                    {showDeckSupervised && (
                        <AutoField
                            field={fields['deck_performed_under_supervision_days']}
                            name='deck_performed_under_supervision_days'
                        />
                    )}
                    <p />
                    {vesselType === 'Towing'
                        ? [
                              <AutoField
                                  field={fields['towing_training']}
                                  name='towing_training'
                                  onChange={updateTowingTraining}
                              />,
                              showTowingTraining ? (
                                  <AutoField
                                      field={
                                          fields[
                                              'towing_training_and_observation_days'
                                          ]
                                      }
                                      name='towing_training_and_observation_days'
                                  />
                              ) : null,
                          ]
                        : null}
                </div>
            )}
            {department === 'Engine' && (
                <div>
                    <p />
                    <AutoField
                        field={fields['engine_supervised']}
                        name='engine_supervised'
                        onChange={updateEngineSupervised}
                    />
                    {showEngineSupervised && (
                        <AutoField
                            field={fields['engine_performed_under_supervision_days']}
                            name='engine_performed_under_supervision_days'
                        />
                    )}
                </div>
            )}
            <Typography variant='body1' align='left'>
                Upon what water type did you serve this time?
            </Typography>
            <AutoField
                field={fields['watertype']}
                name='watertype'
                onChange={updateWatertype}
            />
            {(watertype === 'Oceans' ||
                watertype === 'Near Coastal' ||
                watertype === 'Inland') && (
                <AutoField field={fields['also_polar']} name='also_polar' />
            )}
            <Typography variant='body1' align='left'>
                Enter the start/end dates of for this period of sea service.
            </Typography>
            <AutoField field={fields['date_reported']} name='date_reported' />
            <AutoField field={fields['date_detached']} name='date_detached' />
            <Typography variant='body1' align='left'>
                Don't worry if you have several records on the same vessel on your
                letter - you'll have an opportunity to enter each one.
            </Typography>
            {props.children}
        </Section>
    );
};

export default ShipmentDischarge;
